import {Image, SafeAreaView, ScrollView, Text, TouchableOpacity, View} from "react-native";
import styles from "./styles";
import Icon from "react-native-vector-icons/FontAwesome5";
import React from "react";

export default function About({navigation, route}) {
    return (
        <View style={styles.container}>
            <TouchableOpacity
                onPress={() => navigation.navigate('Home')}>
                <View style={{marginHorizontal:20, marginVertical:50,flexDirection:"row"}}>
                    <Icon
                        name="arrow-left"
                        color='#ddddd'
                        size={20}
                    />
                    <Text style={styles.text}>Back</Text>
                </View>
            </TouchableOpacity>
            <ScrollView>
                <SafeAreaView edges={['right', 'left']} style={{marginHorizontal:50,flex:1}}>
                    <Image source={route.params.appData.logo} style={styles.img}/>
                    <Text style={styles.title}>{route.params.appData.name}</Text>
                    <Text style={styles.body}>{route.params.appData.full_text}</Text>
                </SafeAreaView>
            </ScrollView>
        </View>
    )

}